import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';

class Provider extends Component {

	static childContextTypes = {
		executeAction: PropTypes.func,
		getStore: PropTypes.func
	};

	constructor(props) {
		super(props);
	}

	getChildContext() {
		return {
			getStore: this.props.dispatcher.getStore.bind(this.props.dispatcher),
			executeAction: this.props.dispatcher.executeAction.bind(this.props.dispatcher)
		}
	}

	render() {
		let { children } = this.props;
		return Children.only(children);
	}
}
export default Provider;
